var $6221651ca0306be3$exports = {};
$6221651ca0306be3$exports = {
    "loading": `\u{141}adowanie...`,
    "placeholder": `Zaznacz\u{2026}`
};


export {$6221651ca0306be3$exports as default};
//# sourceMappingURL=pl-PL.module.js.map
